module.exports = __webpack_public_path__ + "img/main6.6118a210.png";